import React from "react";
import UpdatePasswordForm from "./UpdatePasswordForm";
import LocationFilterToolbar from "../../App/LocationFilterToolbar";
import AppBar from "../../components/DefaultAppBar";

const UpdatePasswordContainer = () => (
  <div>
    <AppBar position="static">
      <LocationFilterToolbar noTicketFilter />
    </AppBar>
    <UpdatePasswordForm />
  </div>
);

UpdatePasswordContainer.route = "/update-password";

export default UpdatePasswordContainer;
